// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entry-page[data-v-039807a3]{padding:16px 24px;max-width:1040px;margin:0 auto;color:#4a4a4a}.entry-page>h2[data-v-039807a3]{margin-bottom:40px}.body-button[data-v-039807a3]{margin-bottom:16px}.body-desc[data-v-039807a3]{margin-bottom:32px}.body-form-item[data-v-039807a3]{margin-bottom:16px}.body-form-submit[data-v-039807a3]{margin-top:32px}.body-confirm[data-v-039807a3],.body-items-item[data-v-039807a3]{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
